/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Link from 'next/link'
import { CSSProperties, MouseEventHandler, forwardRef } from 'react'
import { BasicStyledComponent, DSDataAttrs, LinkedLinkProps } from 'shared-definitions/types'

export interface LinkedProps extends LinkedLinkProps, DSDataAttrs {
  title?: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
  style?: CSSProperties
}

const Linked = forwardRef<
  HTMLAnchorElement,
  LinkedProps & React.PropsWithChildren & BasicStyledComponent
>(
  (
    { children, href, className, target, rel, referrerPolicy, title, onClick, style, ...dataAttrs },
    ref
  ) => {
    if (target === '_blank') {
      return (
        // eslint-disable-next-line react/jsx-no-target-blank
        <a
          ref={ref}
          {...dataAttrs}
          referrerPolicy={referrerPolicy}
          style={style}
          href={href}
          className={className}
          onClick={onClick}
          title={title}
          target="_blank"
          rel={rel}
        >
          {children}
        </a>
      )
    }
    return (
      <Link
        ref={ref}
        href={href}
        prefetch={false}
        className={className}
        referrerPolicy={referrerPolicy}
        style={style}
        title={title}
        onClick={onClick}
        {...dataAttrs}
        rel={rel}
      >
        {children}
      </Link>
    )
  }
)

Linked.displayName = 'Linked'

export default Linked
